import React from 'react'
import {
  Image,
  withSitecoreContext,
  RichText,
  Link,
  isEditorActive,
} from '@sitecore-jss/sitecore-jss-react'
import { useMeasure } from 'react-use'
import Youtube from 'react-youtube'
import { SplitModuleModel } from './models/SplitModule.model'
import { SplitModuleProps } from './types/SplitModule.types'
import './index.scss'

const SplitModule = (props: SplitModuleProps) => {
  const isEE = props.sitecoreContext?.pageEditing
  const model = new SplitModuleModel(props)
  const hasVideo =
    model.videoid && model.videoid?.value && model.videoid?.value?.length !== 0

  const [containerRef, { width }] = useMeasure<HTMLDivElement>()

  return (
    <>
      {props.fields && (
        <div
          className={
            model.AlignToTextModule.value ? 'SplitModule__align_container' : ''
          }
        >
          <div
            id={props?.rendering?.uid}
            className={`split-module  ${
              hasVideo
                ? model.imagePosition === 'left' || !model.imagePosition
                  ? 'split-module--video'
                  : model.imagePosition === 'right'
                  ? 'split-module--right--video'
                  : 'split-module--video'
                : model.imagePosition === 'left' || !model.imagePosition
                ? 'split-module'
                : model.imagePosition === 'right'
                ? 'split-module--right'
                : 'split-module'
            }  ${isEditorActive() ? 'splitImageHeight' : null}
					${model.variant?.value === 'v1' ? 'split-module-Extr' : null}
					${hasVideo ? 'split-module_Ex--video' : null}`}
          >
            {hasVideo ? (
              <div className="split-module__videoidctn">
                <div
                  className="split-module__videoid--container"
                  ref={containerRef}
                  style={{
                    height: width * (9 / 16),
                    minHeight: width * (9 / 16),
                  }}
                >
                  <Youtube
                    videoId={model.videoid?.value}
                    style={{
                      width: '100%',
                    }}
                    opts={{
                      height: '100%',
                      width: '100%',
                      playerVars: {
                        // https://developers.google.com/youtube/player_parameters
                        rel: 0,
                        mute: 0,
                        controls: 1,
                        loop: 1,
                        autoplay: 0,
                      },
                    }}
                  ></Youtube>
                </div>
                <div
                  className={
                    'split-module__column--video split-module__content--video'
                  }
                >
                  <RichText
                    tag="p"
                    field={model.eyebrow}
                    className={'split-module__eyebrow'}
                  />
                  <RichText
                    tag="h3"
                    field={model.title}
                    className={
                      'split-module__title--video split-module__titleAA--video'
                    }
                  />
                  <RichText
                    tag="div"
                    field={model.bodyText}
                    className="split-module__text--AA--video"
                  />
                  <div
                    className={
                      'split-module__text__buttons split-module__text__buttonsmt'
                    }
                  >
                    {(isEE || model.link1?.text || model.link1?.href) && (
                      <div className="split-module__text__primary-link cta cta-primary-offwhite">
                        <Link field={model.link1} />
                      </div>
                    )}
                    {(isEE || model.link2?.text || model.link2?.href) && (
                      <div
                        className={
                          'split-module__text__primary-link cta cta-primary-red'
                        }
                      >
                        <Link field={model.link2} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : isEditorActive() ? (
              <>
                <div className="splitmoduleImageEE">
                  <Image
                    loading="lazy"
                    field={model?.image}
                    className={
                      'split-module__column split-module__image split-module__image--desktop splitImageEE'
                    }
                  />
                  <Image
                    loading="lazy"
                    field={
                      model?.imageMobile &&
                      model?.imageMobile?.value
                        ? model?.imageMobile
                        : (!model?.AllowFallbackForMobile ? model?.image : undefined)
                    }
                    className={
                      'split-module__column split-module__image split-module__image--mobile'
                    }
                  />
                </div>
              </>
            ) : (
              <>
                <Image
                  loading="lazy"
                  field={model?.image}
                  className={
                    'split-module__column split-module__image split-module__image--desktop'
                  }
                />
                <Image
                  loading="lazy"
                  field={
                    model?.imageMobile && model?.imageMobile?.value
                      ? model?.imageMobile
                      : (model?.AllowFallbackForMobile ? model?.image : undefined)
                  }
                  className={
                    'split-module__column split-module__image split-module__image--mobile'
                  }
                />

                <div className={'split-module__column split-module__content'}>
                  {model?.eyebrow && (
                    <RichText
                      tag="p"
                      field={model?.eyebrow}
                      className={'split-module__eyebrow'}
                    />
                  )}
                  {model.variant?.value === 'v2' ? (
                    <RichText
                      tag="h3"
                      field={model.title}
                      className={'split-module__title split-module__titleBB'}
                    />
                  ) : model.variant?.value === 'v1' ? (
                    <RichText
                      tag="h3"
                      field={model.title}
                      className={'split-module__title split-module__titleAA'}
                    />
                  ) : (
                    <RichText
                      tag="h3"
                      field={model.title}
                      className={'split-module__title split-module__titleBB'}
                    />
                  )}
                  <RichText
                    tag="div"
                    field={model.bodyText}
                    className={`${
                      model.variant?.value === 'v2'
                        ? 'split-module__text--CC'
                        : 'split-module__text'
                    } ${
                      model.variant?.value === 'v1'
                        ? 'split-module__text--AA'
                        : ''
                    } `}
                  />
                  <div
                    className={
                      'split-module__text__buttons split-module__text__buttonsmt'
                    }
                  >
                    {(isEE || model.link1?.text || model.link1?.href) && (
                      <div className="split-module__text__primary-link cta cta-primary-red">
                        <Link field={model.link1} />
                      </div>
                    )}
                    {(isEE || model.link2?.text || model.link2?.href) && (
                      <div
                        className={
                          'split-module__text__primary-link cta cta-primary-red'
                        }
                      >
                        <Link field={model.link2} />
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default withSitecoreContext()(SplitModule)
